import React from 'react';
import NoDataSvg from '../../assets/img/undraw_no_data_re_kwbl.svg';
import IntlMessage from "../IntlMessage";
import Button from "@mui/material/Button";

export type EmptyResultProps = {
    emptyText?: React.ReactNode,
    onAddClick?: () => void,
    addText?: React.ReactNode;
}

const EmptyResult = ({ emptyText, addText, onAddClick }: EmptyResultProps) => {
    return (
        <div className='row g-4'>
            <div className="center-hor">
                <div className='text-center'>
                    <img
                        width={200}
                        height='auto'
                        src={NoDataSvg}
                        alt={"item.title"}
                        className='img-fluid object-fit-contain'
                    />
                    <h3 className='mt-4 mb-4'>
                        {emptyText || <IntlMessage id="resource.empty.text"/>}
                    </h3>
                    {onAddClick && (
                        <div className='text-center'>
                            <Button
                                color='primary'
                                className='rounded-1'
                                onClick={() => onAddClick()}
                            >
                                {addText || <IntlMessage id='resource.empty.text.btn' />}
                            </Button>
                        </div>
                    )}
                </div>

            </div>
        </div>
    );
};

export default EmptyResult;
